import { IdentityRepositoryInterface } from "../identity-repositories";
import { IdentityStorageService } from "./identity-storage-service";
import { inject, injectWithTransform, singleton } from "tsyringe";
import { Logger, LoggerTransformer } from "@identity/utils";

@singleton()
export class IdentityStorageRepository implements IdentityRepositoryInterface {
  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "UserIdentity")
    private logger: Logger,
    @inject(IdentityStorageService)
    private identityStorageService: IdentityStorageService
  ) {}

  async get(): Promise<string> {
    const userData = await this.identityStorageService.get();
    this.logger.info(userData);

    return userData.ppid;
  }
}
